import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { cn } from '../lib/utils';
import { Menu, X } from 'lucide-react';

export const Navbar: React.FC = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const isApp = location.pathname.startsWith('/app');

  if (isApp) return null;

  const navItems = [
    { name: 'Features', path: '/features' },
    { name: 'Docs', path: '/docs' },
    // { name: 'Research', path: '/research' },
    { name: 'Open Source', path: '/open-source' },
  ];

  return (
    <nav className="h-20 border-b border-[#262626] flex items-center justify-between px-8 glass-panel sticky top-0 z-50 bg-[#0A0A0A]/80 backdrop-blur-md">
      <Link to="/" className="flex items-center gap-3">
        <Logo className="h-8" />
      </Link>
      
      {/* Desktop Menu */}
      <div className="hidden md:flex items-center gap-8">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={cn(
              "text-[10px] font-bold uppercase tracking-widest transition-colors hover:text-emerald-500",
              location.pathname.startsWith(item.path) ? "text-emerald-500" : "text-[#525252]"
            )}
          >
            {item.name}
          </Link>
        ))}
        <Link
          to="/app"
          className="bg-emerald-500 hover:bg-emerald-400 text-black font-bold px-6 py-2 rounded-md transition-all text-[10px] uppercase tracking-widest shadow-[0_0_20px_rgba(16,185,129,0.2)] hover:shadow-[0_0_30px_rgba(16,185,129,0.4)]"
        >
          Launch Debugger
        </Link>
      </div>

      {/* Mobile Menu Toggle */}
      <button 
        className="md:hidden text-white p-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
      </button>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="absolute top-20 left-0 right-0 bg-[#0A0A0A] border-b border-[#262626] p-8 flex flex-col gap-6 md:hidden z-50">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => setIsOpen(false)}
              className={cn(
                "text-sm font-bold uppercase tracking-widest transition-colors hover:text-emerald-500",
                location.pathname.startsWith(item.path) ? "text-emerald-500" : "text-[#525252]"
              )}
            >
              {item.name}
            </Link>
          ))}
          <Link
            to="/app"
            onClick={() => setIsOpen(false)}
            className="bg-emerald-500 text-black font-bold px-6 py-4 rounded-md text-center text-sm uppercase tracking-widest"
          >
            Launch Debugger
          </Link>
        </div>
      )}
    </nav>
  );
};
